import React from "react";

export const Card = ({ children, className }) => {
  return <div className={`rounded-lg shadow-md p-4 ${className}`}>{children}</div>;
};

export const CardContent = ({ children }) => {
  return <div className="mt-2">{children}</div>;
};

export const Button = ({ onClick, children }) => {
  return (
    <button
      className="bg-gold text-black px-4 py-2 rounded hover:bg-yellow-500 transition"
      onClick={onClick}
    >
      {children}
    </button>
  );
};

